<!--
 * @Author: M.D.
 * @Date: 2020-01-19 13:36:09
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="pd-o-w">
    <el-dialog
      class="pd-rule-dia"
      ref="mpDialog"
      :visible.sync="visible"
      :before-close="handleClose"
      width="35%">
      <div class="pd-d-header" slot="title">
        积分明细
      </div>
       <el-tabs class="pd-d-tab" :stretch="true" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all" class="pd-d-tab-p pd-d-tab-all">
          <div class="pd-list-definf" v-if="allArr.length == 0">
            暂无积分明细，快去赚积分吧~
          </div>
          <ul class="pd-list-ul" v-else>
            <li class="pd-list-li" v-for="i in allArr" :key="i.id">
              <div class="pd-list-l">
                <div class="pd-l-l-txt">{{i.changeEvent}}</div>
                <div class="pd-l-l-time">{{ i.createTime }}</div>
              </div>
              <div class="pd-list-r">
                <div class="pd-l-r-p" :class="{'green':i.changeState === 0}">{{i.changeState === 0 ? '+':'-'}} {{i.changeValue}}</div>
              </div>
            </li>
            <el-pagination
              style="margin-top:20px; text-align: right"
              class="gds-l-g-page"
              background
              @current-change="pageChg"
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="total">
            </el-pagination>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="注册获得" name="reg" class="pd-d-tab-p pd-d-tab-reg">
          <div class="pd-list-definf" v-if="regArr.length == 0">
            暂无积分明细，快去赚积分吧~
          </div>
          <ul class="pd-list-ul" v-else>
            <li class="pd-list-li" v-for="i in regArr" :key="i.id">
              <div class="pd-list-l">
                <div class="pd-l-l-txt">{{i.changeEvent}}</div>
                <div class="pd-l-l-time">{{ i.createTime }}</div>
              </div>
              <div class="pd-list-r">
                <div class="pd-l-r-p" :class="{'green':i.changeState === 0}">{{i.changeState === 0 ? '+':'-'}} {{i.changeValue}}</div>
              </div>
            </li>
            <el-pagination
              style="margin-top:20px; text-align: right"
              class="gds-l-g-page"
              background
              @current-change="pageChg"
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="total">
            </el-pagination>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="下单获得" name="ord" class="pd-d-tab-p pd-d-tab-ord">
          <div class="pd-list-definf" v-if="ordArr.length == 0">
            暂无积分明细，快去赚积分吧~
          </div>
          <ul class="pd-list-ul" v-else>
            <li class="pd-list-li" v-for="i in ordArr" :key="i.id">
              <div class="pd-list-l">
                <div class="pd-l-l-txt">{{i.changeEvent}}</div>
                <div class="pd-l-l-time">{{ i.createTime }}</div>
              </div>
              <div class="pd-list-r">
                <div class="pd-l-r-p" :class="{'green':i.changeState === 0}">{{i.changeState === 0 ? '+':'-'}} {{i.changeValue}}</div>
              </div>
            </li>
            <el-pagination
              style="margin-top:20px; text-align: right"
              class="gds-l-g-page"
              background
              @current-change="pageChg"
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="total">
            </el-pagination>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="推荐获得" name="rmd" class="pd-d-tab-p pd-d-tab-rmd">
          <div class="pd-list-definf" v-if="rmdArr.length == 0">
            暂无积分明细，快去赚积分吧~
          </div>
          <ul class="pd-list-ul" v-else>
            <li class="pd-list-li" v-for="i in rmdArr" :key="i.id">
              <div class="pd-list-l">
                <div class="pd-l-l-txt">{{i.changeEvent}}</div>
                <div class="pd-l-l-time">{{ i.createTime }}</div>
              </div>
              <div class="pd-list-r">
                <div class="pd-l-r-p" :class="{'green':i.changeState === 0}">{{i.changeState === 0 ? '+':'-'}} {{i.changeValue}}</div>
              </div>
            </li>
            <el-pagination
              style="margin-top:20px; text-align: right"
              class="gds-l-g-page"
              background
              @current-change="pageChg"
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="total">
            </el-pagination>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="兑换消费" name="csm" class="pd-d-tab-p pd-d-tab-csm">
          <div class="pd-list-definf" v-if="csmArr.length == 0">
            暂无积分明细，快去赚积分吧~
          </div>
          <ul class="pd-list-ul" v-else>
            <li class="pd-list-li" v-for="i in csmArr" :key="i.id">
              <div class="pd-list-l">
                <div class="pd-l-l-txt">{{i.changeEvent}}</div>
                <div class="pd-l-l-time">{{ i.createTime }}</div>
              </div>
              <div class="pd-list-r">
                <div class="pd-l-r-p" :class="{'green':i.changeState === 0}">{{i.changeState === 0 ? '+':'-'}} {{i.changeValue}}</div>
              </div>
            </li>
            <el-pagination
              style="margin-top:20px; text-align: right"
              class="gds-l-g-page"
              background
              @current-change="pageChg"
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="total">
            </el-pagination>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api/api'
// const PAGE_SIZE = 10
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pageSize: 5,
      typeName: '',
      activeName: 'all',
      total: 0,
      currentPage: 1,
      allArr: [],
      regArr: [],
      ordArr: [],
      rmdArr: [],
      csmArr: []
    }
  },
  computed: {

  },
  created () {
    this.getData()
  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    pageChg (v) {
      this.currentPage = v
      this.getData(this.typeName)
    },
    async getData (type = '') {
      let changeType = ''
      switch (type) {
        case 'reg': changeType = 1; break
        case 'ord': changeType = 2; break
        case 'rmd': changeType = 3; break
        case 'csm': changeType = 4; break
      }
      const re = await API.getPointDetail({
        changeType,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (changeType === '') {
        this.allArr = re.data.result.records
        this.total = Number(re.data.result.total || 0)
      } else {
        this[`${type}Arr`] = re.data.result.records
        this.total = Number(re.data.result.total || 0)
      }
    },
    handleClose (d) {
      this.$emit('visChg', false)
      // d()
    },
    handleClick (v) {
      this.currentPage = 1
      this.getData(v.name)
      this.typeName = v.name
    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.pd-o-w
  .pd-rule-dia
    .pd-d-header
      color theme-color
    .pd-d-tab
      .pd-d-tab-p
        min-height 300px
        position relative
        .pd-list-definf
          center()
          min-height 200px
          color #aaaaaa
      .pd-list-ul
        padding 10px 20px
        .pd-list-li
          display flex
          height 70px
          border-bottom 1px solid #eeeeee
          .pd-list-l
            flex 1 1 auto
            >div
              height 35px
              line-height 35px
            .pd-l-l-txt
              font-size 18px
              color #000000
              line-height 40px
            .pd-l-l-time
              font-size 14px
              color #999999
          .pd-list-r
            flex 0 0 200px
            center()
            justify-content flex-end
            .pd-l-r-p
              color #E81414
              &.green
                color theme-color
      .pd-d-tab-all
        padding 0
</style>
